import { resolveConceptsBySource } from './conceptSource'

/** 分析页不参与展示与计分的概念（可扩展） */
export const EXCLUDED_ANALYSIS_CONCEPTS = ['融资融券', '深股通', '沪股通']

const EXCLUDED_SET = new Set(EXCLUDED_ANALYSIS_CONCEPTS)

export function isExcludedAnalysisConcept(name) {
  return EXCLUDED_SET.has(String(name || '').trim())
}

export function filterAnalysisConcepts(concepts) {
  return (Array.isArray(concepts) ? concepts : [])
    .map((c) => String(c || '').trim())
    .filter(Boolean)
    .filter((c) => !EXCLUDED_SET.has(c))
}

export function resolveAnalysisConcepts(concepts, kplConcepts, source, localConcepts) {
  return filterAnalysisConcepts(resolveConceptsBySource(concepts, kplConcepts, source, localConcepts))
}
